export default __webpack_public_path__ + "static/media/instagram.2353ee70.svg";